import { alphanumeric } from '@/services/compose'
import { v4 as uuidv4 } from 'uuid'

interface WizardState {
  uuid: string
  adminPassword: string
  selectedDevice?: string
  selectedLocation?: string
  selectedNamespace?: string
  deploymentName?: string
  tokenHistory: {
    node: {
      [s: string]: string
    },
    vault: {
      [s: string]: string
    }
  }
}

const wizard = {
  state: {
    uuid: uuidv4().substring(0, 8),
    adminPassword: alphanumeric(10),
    selectedDevice: false,
    selectedLocation: false,
    selectedNamespace: false,
    deploymentName: false,
    tokenHistory: {
      node: {},
      vault: {}
    }
  },
  mutations: {
    resetWizard (state: WizardState) {
      state.uuid = uuidv4().substring(0, 8)
      state.adminPassword = alphanumeric(10)
      state.selectedDevice = undefined
      state.selectedLocation = undefined
      state.selectedNamespace = undefined
      state.deploymentName = undefined
      state.tokenHistory = {
        node: {},
        vault: {}
      }
    },
    setDevice (state: WizardState, device: string) {
      state.selectedDevice = device
    },
    setLocation (state: WizardState, location: string) {
      state.selectedLocation = location
    },
    setNamespace (state: WizardState, namespace: string) {
      state.selectedNamespace = namespace
    },
    setDeploymentName (state: WizardState, deploymentName: string) {
      if (deploymentName.length > 0) {
        state.deploymentName = deploymentName
      } else {
        state.deploymentName = undefined
      }
    }
  }
}

export default wizard
